import styled from 'styled-components';

import { Flex } from 'src/client/components';

export const Container = styled(Flex)`
  flex-wrap: wrap;
  gap: 8px;
`;
